import React from 'react';
import { Col } from 'react-bootstrap';

const StepDivider = ({ className, ...props }) => (
  <Col sm={2} xs={1} className={['bg-info my-4 my-md-0 col', className].join(' ')} {...props} />
);

export default StepDivider;
